/**
 * Offizielles gtag-Bootstrap-Snippet (`function gtag(){dataLayer.push(arguments)}`),
 * typsicher nachgebildet.
 *
 * ⛔ NIEMALS zu `(...args: unknown[]) => dataLayer.push(args)` "vereinfachen".
 *
 * gtag.js/GTM erkennt einen dataLayer-Eintrag nur dann als Kommando, wenn er ein
 * `arguments`-Objekt ist (`[object Arguments]`). Ein echtes Array
 * (`[object Array]`) — und ein Rest-Parameter IST ein echtes Array — wird
 * **stillschweigend verworfen**, auch beim Replay ab Index 0. Es gibt keine
 * Warnung, keinen Fehler, nur fehlende Daten.
 *
 * Genau das war #717: vom 12.07. bis 03.08.2026 wurden `consent default`, `set`,
 * `js`, `config AW-…` und **jedes** `event conversion` ignoriert. Google Ads
 * meldete 0,00 Conversions all-time bei laufendem Spend, und Consent Mode v2
 * Advanced war faktisch nie aktiv (live verifiziert 2026-08-02 auf locari.ai:
 * `google_tag_data.tidr.destination` leer, null Requests an googleadservices —
 * nach manuellem Bootstrap im `arguments`-Format sofort volle Hit-Batterie).
 *
 * Eine Arrow-Function hat kein eigenes `arguments` → hier ist eine parameterlose
 * `function`-Deklaration Pflicht, kein Stilmittel.
 *
 * Bewusste Abweichung vom Original-Snippet: die Factory schließt die
 * `dataLayer`-**Referenz** ein, während das Original die globale Variable bei
 * jedem Call neu liest. Praktisch folgenlos (gtag.js ersetzt `window.dataLayer`
 * nicht, es patcht nur dessen `push`) — hier explizit benannt, weil "typsicher
 * nachgebaut ≠ äquivalent" genau die Fehlerklasse ist, die #717 verursacht hat.
 */
export function createGtagStub(
  dataLayer: unknown[],
): (...args: unknown[]) => void {
  function gtag(this: unknown) {
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments);
  }

  // Cast bewusst auf die LOKALE Bindung, nicht auf `window.gtag = …`:
  // `() => void` ist an `(...args: unknown[]) => void` zuweisbar, aber die
  // lokalen Aufrufe `gtag('consent', 'default', {…})` liefen sonst gegen die
  // 0-Parameter-Signatur (TS2554).
  return gtag as (...args: unknown[]) => void;
}
